// extracted by mini-css-extract-plugin
export default {"info":"dbdWe","title":"lm1NO"};